import { createAuthRequestHeaders } from './create-auth-request-headers';

interface IPostFetchOptionsParams {
  cookieHeader: string;
  body: unknown;
}

export function createPostFetchOptions({
  cookieHeader,
  body,
}: IPostFetchOptionsParams): RequestInit {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...createAuthRequestHeaders(cookieHeader),
    },
    body: JSON.stringify(body),
  };
}
